import React, { Component } from 'react'
import Slider from 'src/components/slider';
import { Image, Card, OverlayTrigger } from 'react-bootstrap'
import Tooltip from "src/components/tooltip";
import dateformat from 'dateformat';
import isEqual from "is-equal";
import PlaceholderEmptyMessage from "src/legacy/components/PlaceholderEmptyMessage";
import ContactListEmptyMessage from "src/legacy/images/Ilustration - changed Hub settings.svg";
import RolodexEmptyMessage from "src/legacy/images/rolodexEmptyMessage.svg";
import { localizedStrings } from 'src/localization/index.jsx';
import _ from 'lodash';
import cx from 'classnames'
import styles from './styles.module.scss'
import Button from 'src/components/button';
import Text from 'src/components/text';


export default class HubSettingsView extends Component {

  constructor(props) {
    super(props)

    this.state = {
      showManageAccess: false,
      showDeleteHub: false,
      minimizeHub: false,
      id: 1,
      layouts: this.props.layouts || [],
      selectedGroups: [],
      layout: '',
      layoutNameChange: false,
      updated: this.props.updated || false
    }

    this.handleMinimizeHub = this.handleMinimizeHub.bind(this);
    this.handleUpdateGroupsForLayouts = this.handleUpdateGroupsForLayouts.bind(this);
    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleManageLayout = this.handleManageLayout.bind(this);
    this.renderLayoutsEmptyMessage = this.renderLayoutsEmptyMessage.bind(this);

    this.localizedKeywords = localizedStrings.keywords;
    this.localizedCommons = localizedStrings.commons;
    this.localizedLoading = this.localizedCommons.loading;
    this.localizedCommonsActions = this.localizedCommons.actions;
    this.localizedSettings = localizedStrings.pages.settings;
    this.localizedHubSettings = this.localizedSettings.account.hub_settings; 
  }

  componentDidMount() {
    this.props.fetchAllHubLayouts(true);
    this.props.fetchUserManagementList( 0, "", "user_groups");
  }

  componentWillReceiveProps(nextProps) {
    if (!isEqual(this.props.layouts, nextProps.layouts) || !isEqual(this.props.enablingAccess, nextProps.enablingAccess)) {
      this.setState({
        layouts: nextProps.layouts,
        layout: nextProps.layouts[1]
      })
    }

    if (!isEqual(this.props.updated, nextProps.updated)) {
      this.setState({
        updated: nextProps.updated
      });

      if(nextProps.updated){
        this.props.fetchAllHubLayouts(true);
      }
    }
  }

  _renderFirstUserIcon(user) {
    return [
      <Image
        className={cx(styles.userGroupIcon, styles.firstIcon)}
        src={user.icons[0].thumbnail}
        circle
      />,
      <div className={styles.defaultImage2}>
        <div className={cx(styles.userGroupCount1)}></div>
      </div>,
      <div className={styles.userGroupContainer}>
        <div className={cx(styles.userGroupCount1)}></div>
      </div>
    ];
  }

  _renderSecondUserIcon(user) {
    return [
      <Image
        className={cx(styles.userGroupIcon, styles.firstIcon)}
        src={user.icons[0].thumbnail}
        circle
      />,
      <Image
        className={cx(styles.userGroupIcon, styles.layer1)}
        src={user.icons[1].thumbnail}
        circle
      />,
      <div>
        <div className={styles.userGroupContainer}>
          <div className={cx(styles.userGroupCount1)}>
            {user.usersCount > 2 ? `+${user.usersCount - 2}` : ""}
          </div>
        </div>
      </div>
      ,
    ];
  }

  _renderDefaultIcon() {
    return [
      <div className={cx(styles.defaultImage1, styles.firstIcon)}>
        <div className={cx(styles.userGroupCount1)}></div>
      </div>,
      <div className={styles.defaultImage2}>
        <div className={cx(styles.userGroupCount1)}></div>
      </div>
      ,
      <div className={styles.userGroupContainer}>
        <div className={cx(styles.userGroupCount1)}></div>
      </div>
      ,
    ];
  }

  handleMinimizeHub(index) {
    if(index != 0){
      this.setState(prevState => {
        return {
          id: prevState.id === index ? -1 : index,
          minimizeHub: !prevState.minimizeHub,
          layout: this.state.layouts[index]
        }
      })
    }
  }

  handleUpdateGroupsForLayouts() {

    if (this.state.groupChanges) {
      this.props.enableLayoutAccessForUserGroups({layoutId: this.state.layout.id, userGroups: this.state.selectedGroups});
      this.setState({
        showManageAccess: false,
        groupChanges: false
      });
    }

    var layout = {
      layoutName: _.get(this.state, "layout.name", ""),
      rows: this.state.layout.rows,
    }
    
    if (this.state.layout.isUpdateName) {
      this.props.updateHubLayout({id: _.get(layout, "id"), layout });

      this.setState({
          showManageAccess: false,
          layoutNameChange: false,
      });
    }
  }

  handleInputChange(e) {
    this.setState({
      layout: {
        ...this.state.layout,
        layoutName: e.target.value,
        isUpdateName: true
      }
    })
  }

  handleManageLayout(layout) {
    this.setState({
      showManageAccess: true,
      layout: layout,
      selectedGroups: _.map(layout.userGroups, 'id'),
      layoutName: _.get(layout, "name", "")
    })
  }

  renderGroup(group) {
    if (group != null) {
      return (
        <div className={cx(styles.groupContainer)}>
          <div key={group.id} className={styles.group} onClick={() => this.handleSelectGroup(group.id)}>
            <Card className={cx(styles.groupIcons)}>
              <div>
                {_.size(group.icons) === 1 && this._renderFirstUserIcon(group)}
                {_.size(group.icons) >= 2 && this._renderSecondUserIcon(group)}
                {_.size(group.icons) === 0 && this._renderDefaultIcon()}
              </div>
            </Card>
            <div className={styles.groupContent}>
              <OverlayTrigger placement="top" overlay={<Tooltip id="tooltip">{group.name}</Tooltip>}>
              <p className={styles.groupName}>
              {group.name}
              </p>
              </OverlayTrigger>
              <p className={styles.groupCount}>{group.usersCount} {group.usersCount === 1 ? "user" : "users"}</p>
              <p className={styles.createdDate}>{this.localizedCommons.created_on}: {dateformat(group.createdDate, 'dd/mm/yyyy')} </p>
            </div>
          </div>
        </div>
      )
    }
  }

  handleSelectGroup(groupId) {

    this.setState({
      groupChanges: true
    })

    let selectedGroups = []

    if (_.size(this.state.selectedGroups) === 0) {
      this.setState({ selectedGroups: [groupId] })
    }
    else {
      if (!_.includes(this.state.selectedGroups, groupId)) {
        selectedGroups = [...this.state.selectedGroups, groupId]
      }
      else {
        selectedGroups = _.without(this.state.selectedGroups, groupId)
      }
      this.setState({
        selectedGroups: selectedGroups
      })
    }
  }

  renderSelectionGroups() {
    return (
      <div className={styles.groupContainer}>
        {this.props.userGroups.map(group => (
          <div key={group.id}>
            <div className={styles.selectIcon}>
              <i className={cx(`paperflite-${_.includes(this.state.selectedGroups, group.id) ? 'tick-selected' : 'radio-button-unselected'}`)} aria-hidden="true" onClick={() => this.handleSelectGroup(group.id)}></i>
            </div>
              {this.renderGroup(group)}
          </div>
        ))
        }
      </div>
    )
  }

  renderLayoutsEmptyMessage() {
    return (
      <PlaceholderEmptyMessage
        title={this.localizedHubSettings.empty_message.no_layouts.title}
        message={this.localizedHubSettings.empty_message.no_layouts.sub_text}
        image={RolodexEmptyMessage}
        className={styles.emptyHubsIcon}
        visible={true}
      />
    )
  }

  renderHubs() {
    var children = Array();

    this.state.layouts.forEach((layout, index) => {
      children.push(
        <div
          key={layout.id}
          className={cx(styles.hubContainer, {
            [styles.minimizeHubContainer]: this.state.id !== index,
          })}
        >
          <div
            className={styles.headerContainer}
            onClick={() => {
              this.state.id != index && this.handleMinimizeHub(index);
            }}
          >
            <div className={styles.hubHeader}>
              <span
                className={cx(styles.hubIndex, {
                  [styles.activeHubIndex]: this.state.id == index,
                })}
              >
                {index + 1}
              </span>
              <span
                data-tip={_.get(layout, "name", "")}
                data-for={`tooltip-${index}`}
                className={cx(styles.hubName, {
                  [styles.activeHubName]: this.state.id === index,
                  [styles.defaultLayoutName]: !layout.userDefined,
                })}
              >
                <div className={styles.hubNameText} >
                  <Text text={_.get(layout, "name", "")} lines={1}  />
                </div>
                {this.state.id != index && layout.userDefined && (
                  <div className={styles.expandButton}>
                    <i className="paperflite-dropdown" />
                  </div>
                )}
              </span>
            </div>
            {!layout.userDefined && (
              <p className={styles.defaultLayout}>
                {this.localizedHubSettings.default_layout}
              </p>
            )}
            <div className={styles.actionContainer}>
              {this.state.id == index && (
                <div>
                  <button
                    className={styles.manageAccess}
                    onClick={() => this.handleManageLayout(layout)}
                  >
                    <i className="paperflite-edit" />{" "}
                    {this.localizedHubSettings.actions.manage_layout}
                  </button>
                  {layout.userDefined && (
                    <button
                      className={styles.deleteHubButton}
                      onClick={() => this.setState({ showDeleteHub: true })}
                    >
                      <i className="paperflite-delete" />
                      <span className={styles.deleteLabel}>
                        {this.localizedHubSettings.actions.delete_layout}
                      </span>
                    </button>
                  )}
                </div>
              )}
              {layout.userDefined && this.state.id != index && (
                <div>
                  <button
                    className={styles.deleteHub}
                    onClick={() => this.setState({ showDeleteHub: true })}
                  >
                    <i className="paperflite-delete" />
                    <span className={styles.deleteLabel}>
                      {this.localizedHubSettings.actions.delete_layout}
                    </span>
                  </button>
                </div>
              )}
            </div>
          </div>
          <div className={cx(styles.hubDetailsRow, styles.userGroupsContainer)}>
            <div className={styles.hubSubText}>
              <p>{this.localizedHubSettings.edit}</p>
            </div>
            <div className={styles.groupRow}>
              {layout.userGroups &&
                layout.userGroups.map((group) => this.renderGroup(group))}
            </div>
            {(layout.userGroups == null || layout.userGroups.length < 1) && (
              <div className={styles.emptyMessage}>
                <PlaceholderEmptyMessage
                  title={this.localizedHubSettings.empty_message.no_group.title}
                  message={
                    this.localizedHubSettings.empty_message.no_group.sub_text
                  }
                  image={ContactListEmptyMessage}
                  className={styles.emptyMessageIcon}
                  visible={true}
                />
              </div>
            )}
          </div>
        </div>,
      );
    })

    return children;
  }


  render() {

    return (
      <div className={styles.hubSettingsContainer}>
        <div className={styles.innerContent}>
          <div className={styles.heading}>{this.localizedHubSettings.title}</div>

          {this.state.layouts.length > 0 && !this.props.loading && this.renderHubs()}

          <div className={styles.layoutsEmptyMessage}>
            {this.state.layouts.length <= 0 && !this.props.loading && this.renderLayoutsEmptyMessage()}
            {this.props.loading &&
              <p className={styles.loadingMessage}>{this.localizedLoading.layout}...</p>
            }
          </div>

          <Slider.Dialog width={"380"} show={this.state.showManageAccess}>
            <div className={styles.sliderContainer}>
              <div className={styles.header}>
                <p className={styles.title}>
                  {this.localizedHubSettings.manage_layout.title}
                </p>
                <p className={styles.subText}>
                  {this.localizedHubSettings.manage_layout.sub_text}
                </p>
              </div>
              <div>
                <input
                  className={styles.layoutName}
                  value={_.get(this.state, "layout.name")}
                  onChange={(e) => this.handleInputChange(e)}
                ></input>
              </div>
              <div className={styles.userGroupsContainer}>
                <p className={styles.listHeader}>
                  {" "}
                  {this.localizedHubSettings.manage_layout.user_groups_list}
                </p>
                {this.renderSelectionGroups()}
              </div>

              <div className={styles.silderButtonContainer}>
                <Button
                icon='paperflite-tick'
                  text={
                    this.props.enablingAccess
                      ? `${this.localizedCommonsActions.confirming}...`
                      : this.localizedCommonsActions.confirm
                  }
                  variant="primary"
                  disabled={this.props.enablingAccess}
                  onClick={() => this.handleUpdateGroupsForLayouts()}
                />

                <Button
                  text={this.localizedCommonsActions.cancel}
                  variant="secondary"
                  onClick={() => {
                    this.setState({
                      showManageAccess: false,
                    });
                  }}
                />
              </div>
            </div>
          </Slider.Dialog>

          <Slider.Dialog width={"380"} show={this.state.showDeleteHub}>
            <div className={styles.sliderContainer}>
              <div className={styles.header}>
                <p className={styles.title}>
                  {this.localizedHubSettings.delete_layout.title}
                </p>
                <p className={styles.subText}>
                  <p>
                    {" "}
                    {localizedStrings.formatString(
                      this.localizedHubSettings.delete_layout.sub_text,
                    )}{" "}
                  </p>
                  <p className={styles.subTitle}>
                    "{_.get(this.state, "layout.name")}"?
                  </p>
                </p>
              </div>
              <div className={styles.buttonTray}>
                <Button
                icon='paperflite-tick'
                  text={
                    this.props.deleting
                      ? `${this.localizedCommonsActions.confirming}...`
                      : this.localizedCommonsActions.confirm
                  }
                  variant="primary"
                  disabled={this.props.deleting}
                  onClick={() => {
                    this.props.deleteHubLayout(this.state.layout.id);
                    this.setState({ showDeleteHub: false });
                  }}
                />

                <Button
                  text={this.localizedCommonsActions.cancel}
                  variant="secondary"
                  onClick={() => this.setState({ showDeleteHub: false })}
                />
              </div>
            </div>
          </Slider.Dialog>
        </div>
      </div>
    );
  }
}
